import { I as Icon, _ as _extends } from './Icon-465858dc.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Link = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M7.004 9a3 3 0 100 6h3.4954c0 1-.8738 2-1.7477 2H7.0039a5 5 0 010-10h2.0973c.6991 0 1.3982 1 1.3982 2H7.0039zm9.9921 0a3 3 0 010 6h-3.4955c0 1 .8738 2 1.7477 2h1.7478a4.9999 4.9999 0 003.5355-8.5355A4.9999 4.9999 0 0016.9961 7h-2.0973c-.6991 0-1.3982 1-1.3982 2H16.9961zm-9.4922 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9z",
      clipRule: "evenodd"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M7.004 9a3 3 0 100 6h3.4954c0 1-.8738 2-1.7477 2H7.0039a5 5 0 010-10h2.0973c.6991 0 1.3982 1 1.3982 2H7.0039zm9.9921 0a3 3 0 010 6h-3.4955c0 1 .8738 2 1.7477 2h1.7478a4.9999 4.9999 0 003.5355-8.5355A4.9999 4.9999 0 0016.9961 7h-2.0973c-.6991 0-1.3982 1-1.3982 2H16.9961zm-9.4922 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-9z",
      clipRule: "evenodd"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Link.displayName = "LinkIcon";

export { Link, Link as default };
